import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { ActivityRequestParams, ActivityDetail } from './type';

const model = {
  state: {
    couponData: [],
    insertActivityTargetIdList: [],
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { redPacketManage }, getState }: { dispatch: any; getState: any }) => ({
    // 获取优惠券接口
    async getCoupon(value) {
      redPacketManage.setState({
        couponData: [],
        couponDataFetching: true,
      });
      try {
        const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getCouponsByName', {
          type: 'GET',
          params: filterNull({
            name: value,
          }),
        });
        if (data) {
          const couponData = data.map((d) => ({
            label: d.platformCouponName,
            id: d.platformCouponBatchId,
          }));
          redPacketManage.setState({ couponData });
        }
      } catch (error) {
        console.error('获取优惠券失败:', error);
      } finally {
        redPacketManage.setState({ couponDataFetching: false });
      }
    },
    // 更改活动状态接口 参数 activityId，status：1 初始化 2 上线 3 下线 5 删除
    async changeStatus(params) {
      const data = await fetch('/saasmerchant/web/activity/changeActivityStatus', {
        type: 'POST',
        params,
        useJson: true,
      });
      return data;
    },
    // 创建红包活动接口
    async addActivity(params: ActivityRequestParams) {
      const data = await fetch('/saasmerchant/web/activity/add', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 编辑红包活动接口
    async editActivity(params: ActivityRequestParams) {
      const data = await fetch('/saasmerchant/web/activity/edit', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 获取活动详情接口
    async getActivityDetail(params: { activityId: string }) {
      const data: ActivityDetail = await fetch('/saasmerchant/web/activity/getActivityById', {
        type: 'GET',
        params,
      });
      return data;
    },
    // 编辑目标人群优惠券
    async editActivityTarget(params) {
      const data = await fetch('/saasmerchant/web/activityTarget/edit', {
        type: 'POST',
        params,
        useJson: true,
      });
      return data;
    },
    // 创建目标人群优惠券
    async addActivityTarget(params) {
      const data = await fetch('/saasmerchant/web/activityTarget/add', {
        type: 'POST',
        params,
        useJson: true,
      });
      return data;
    },
    // 删除目标人群优惠券
    async delActivityTarget(params) {
      const data = await fetch('/saasmerchant/web/activityTarget/del', {
        type: 'POST',
        params,
        useJson: true,
      });
      return data;
    },
    // 更新目标人群优惠券
    async updateActivityTarget(params) {
      const data = await fetch('/saasmerchant/web/activityTarget/getDetailById', {
        type: 'GET',
        params,
      });
      return data;
    },
    // 设置配置信息id
    setInsertActivityTargetIdList(insertActivityTargetIdList) {
      redPacketManage.setState({ insertActivityTargetIdList });
    },
  }),
};

export default model;
